<div data-row-span="12" [formGroup]="fuelEvent">
  <div data-field-span="2" flValidationState="totalGallons">
    <label>Gallons</label>
    <input type="number" formControlName="totalGallons" min="0" />
  </div>
  <div data-field-span="3" flValidationState="fuelSourceType">
    <label>Fuel Source</label>
    <label
      ><input type="radio" formControlName="fuelSourceType" value="AmghBulk" />&nbsp;AMGH
      Bulk</label
    >&nbsp;
    <label class="no-wrap"
      ><input type="radio" formControlName="fuelSourceType" value="Fbo" />&nbsp;FBO</label
    >
  </div>
  <div *ngIf="isAmghBulk$ | async" data-field-span="5">
    <label>AMGH Fuel Tank</label>
    <fl-amgh-fuel-tank-select [fuelTankId]="fuelTankId"></fl-amgh-fuel-tank-select>
  </div>
  <div *ngIf="isFbo$ | async" data-field-span="5">
    <label>FBO Fuel Tank</label>
    <fl-fbo-fuel-tank-autocomplete [fboId]="fboId"></fl-fbo-fuel-tank-autocomplete>
  </div>
  <div data-field-span="2">
    <label>Payment Type</label>
    <mat-select formControlName="paymentType">
      <mat-option *ngFor="let option of paymentOptions" [value]="option.value">{{
        option.label
      }}</mat-option>
    </mat-select>
  </div>
</div>
<fl-message-box [messages]="validationErrors$ | async" [level]="'error'"></fl-message-box>
